import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { Switch } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import sharing from '../images/sharing.png';
import gvLogo from '../images/gvLogo.png';

import {
  isSharing,
} from '../../redux/sharingSlice';

import '../css/home.css';

export default function Agree() {
  const theme = useTheme();
  // const [checked, setChecked] = React.useState(false);

  const sharingState = useSelector((state) => state.sharing.isSharing);

  const dispatch = useDispatch();

  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          // backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#60a5fa',

          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  const handleChange = (event) => {
    // setChecked(event.target.checked);
    dispatch(isSharing(event.target.checked));
    console.log('Status: ', event.target.checked);
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: '#3B4E68',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          paddingBottom: '10px',
        }}
      >

        <Box>

          <Box>
            <img src={gvLogo}
              alt="gridvault logoprivacy image"
              className='home-icon'
              style={{ width: '100%' }}
            />
          </Box>

          <img src={sharing}
            alt="data sharing image"
            className='home-icon'
            style={{ width: '100%' }}
          />

          <Box>
            <Typography
              variant='h4'
              sx={{
                color: 'white',
                padding: '20px',
                paddingTop: '0px',
                fontSize: '22px',
                fontWeight: 'bold',
              }}
            >
              Help us to improve Gridvault Authenticator
            </Typography>

            <Typography
              variant='body1'
              sx={{
                color: 'white',
                fontSize: '14px',
                paddingLeft: '20px',
                paddingRight: '20px',
              }}
            >
              By allowing us to collect additional non-personal data, you will help us improve the app. You can turn this on or off any time in the Settings page.
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
            }}

          >

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '20px',
              }}>
              <Box
                sx={{
                  color: '#FFFFFF',
                  fontSize: '14px',
                  paddingRight: '10px',
                }}
              >
                Help us improve the app by sharing your app usage data
              </Box>
              {/* <Switch
                checked={checked}
                onChange={handleChange}
              /> */}
              <IOSSwitch
                // checked={checked}
                checked={sharingState}
                onChange={handleChange}
              />
            </Box>

          </Box>


        </Box>

        <Box>
          <Box
            sx={{
              paddingBottom: '10px',
              width: '100%',
            }}
          >
            <Link to='/register' >
              <Button
                sx={{
                  backgroundColor: '#3c82f6',
                  border: '1px solid #3B4E68',
                  color: '#FFFFFF',
                  width: '90%',
                  '&:hover': {
                    border: '1px solid #FFFFFF',
                    color: '#FFFFFF',
                  }
                }}
              >
                Continue
              </Button>
            </Link>
          </Box>

          <Box
            sx={{
              fontSize: '0.8rem',
            }}
          >
            <Link
              to='/privacy-statement'
              className="gv-links"
            // style={{ color: '#60a5fa', textDecoration: 'none', '&:hover': { color: '#FFFFFF' } }}
            >
              Gridvault Privacy Statement
            </Link>
          </Box>

        </Box>

      </Box>
    </React.Fragment >
  );
}